<section class=" bg-charcoal relative overflow-hidden" aria-labelledby="why-us-heading">
  <!-- Decorative blurs -->
  <div class="absolute w-[500px] h-[500px] -top-64 -left-64 rounded-full blur-[100px]"
       style="background-color: #640DA920;"></div>
  <div class="absolute w-[500px] h-[500px] -bottom-64 -right-64 rounded-full blur-[100px]"
       style="background-color: #D420A420;"></div>
  <div
      class="absolute w-[400px] h-[400px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-full blur-[120px]"
      style="background-color: #44A2FA10;"></div>

  <!-- Background gradient -->
  <div class="absolute inset-0 opacity-30"
       style="background: linear-gradient(to bottom right, #640DA905, #44A2FA10, #D420A405);"></div>

  <div class="container mx-auto px-4 md:px-6 relative z-10">
    <!-- Section header -->
    <div class="text-center mb-4 lg:mb-16" data-aos="fade-up">
      <h2 id="why-us-heading" class="section-title">Discover what sets us apart</h2>
      <p class="text-lg text-white/70 max-w-3xl mx-auto mt-4">
        Our cutting-edge AI technology offers unmatched capabilities for matching visual content with the perfect
        soundtrack.
      </p>
    </div>

    <!-- Feature cards grid - styled like vibe-sync design -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 max-w-8xl mx-auto">
      <!-- Feature cards using ngFor to iterate through reasons array -->
      @for (reason of reasons; track reason; let i = $index) {
        <div
            [attr.data-aos]="'fade-up'"
            class="feature-card group relative overflow-hidden bg-dark-gray rounded-3xl border border-border/50 hover:border-white/30 transition-all duration-700"
            style="animation: slideInFromBottom 0.8s ease-out forwards">
          <!-- Animated background -->
          <div class="card-gradient" [style.background-color]="cardColors[i]"></div>
          <!-- Top geometric pattern -->
          <div class="top-pattern">
            <div class="pattern-box-1" [style.background-color]="cardColors[i]"></div>
            <div class="pattern-box-2" [style.background-color]="cardColors[i]"></div>
          </div>
          <div class="relative p-4 h-full flex flex-col">
            <!-- Icon and Title on same line -->
            <div class="flex items-center mb-4">
              <div class="icon-container" [style.background-color]="cardColors[i]">
                <!-- Using Lucide icon component with dynamic name -->
                <lucide-icon [name]="reason.icon" [strokeWidth]="1.5" class="w-6 h-6 text-white"></lucide-icon>
              </div>
              <h3 class="card-title text-xl font-bold text-white ml-4">{{ reason.title }}</h3>
            </div>
            <!-- Content -->
            <div class="flex-1">
              <p class="text-white/70 leading-relaxed text-sm">{{ reason.description }}</p>
            </div>
            <!-- Bottom accent line -->
            <div class="accent-line">
              <div class="accent-fill" [style.background-color]="cardColors[i]"></div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</section>
